import config from "@genai/config";
import { authenticate } from "../src";

export const loginLoader = async () => {
  if (!config.enableOktaAuth) return { authenticated: true };
  return await authenticate();
};
